import { IsOptional, Length } from 'class-validator';
import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';

export class DiscountTypeDto extends BaseDto {
  merchantGroupId: number;
  name: string;
  discountModeId: number;
  percent: number;
  enabled: boolean;
  isComplimentary: boolean;
  enabledForThisMerchant: boolean;
  merchants: MerchantDto[];
  @IsOptional()
  @Length(6, 6)
  voucherCode?: string;
  sequence: number;
  hasManagerAuthorisation: boolean;
  isStaffSales: boolean;
  startDate: string;
  endDate: string;
  useVoucherCode?: boolean;
}
